<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/yssl/back1.png`,
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/yssl.scss";

.wrap {
  position: relative;
  @include common-window();
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.45rem;
      left: 0.46rem;
      width: .35rem;
      height: .3rem;
    }
  }
  > main {
    color: #333333;
    padding: 0.18rem 0.44rem {
      bottom: 2rem;
    };
    overflow-y: auto;
    word-wrap: break-word; // 只对英文起作用，以单词作为换行依据。
    white-space: pre-wrap;
    height: 2.7rem;
    .btnWrap {
      display: inline-block;
      position: absolute;
      bottom: .5rem;
      left: 0;
      right: 0;
      margin: auto;
      width: 6.05rem;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      .btn {
        @include common-button();
        width: 3rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
    }
    > main {
      color: #ffffff;
      padding: 9px 22px {
        bottom: 100px;
      };
      overflow-y: auto;
      word-wrap: break-word; // 只对英文起作用，以单词作为换行依据。
      white-space: pre-wrap;
      height: 135px;
      .btnWrap {
        display: inline-block;
        position: absolute;
        bottom: 35px;
        left: 0;
        width: 302px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .btn {
          @include full-screen-button();
          width: 150px;
        }
      }
    }
  }
}
</style>